/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_TitleInputs */

const en_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Audio`)
};

const fr_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrer l'audio`)
};

const de_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio einbetten`)
};

const it_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora l'audio`)
};

const ru_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить аудио`)
};

const es_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar audio`)
};

const zh_cn2_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入音频`)
};

const ja_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声を埋め込む`)
};

const hi_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड करें`)
};

const pt_pt2_audio_embed_export_title = /** @type {(inputs: Audio_Embed_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar áudio`)
};

/**
* | output |
* | --- |
* | "Embed Audio" |
*
* @param {Audio_Embed_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_title = /** @type {((inputs?: Audio_Embed_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_title(inputs)
	if (locale === "de") return de_audio_embed_export_title(inputs)
	if (locale === "it") return it_audio_embed_export_title(inputs)
	if (locale === "ru") return ru_audio_embed_export_title(inputs)
	if (locale === "es") return es_audio_embed_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_title(inputs)
	if (locale === "ja") return ja_audio_embed_export_title(inputs)
	if (locale === "hi") return hi_audio_embed_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_title(inputs)
	return en_audio_embed_export_title(inputs)
});